import fileDownload from 'js-file-download';

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3001'
  : 'https://sideop-file-server.hermosillo.gob.mx';

const obtenerMensajeError = (err) => (
  (err.response && err.response.data && err.response.data.message) || err.message
);

export default {
  methods: {
    async mixDescargarArchivo(data, origen) {
      this.mostrarDescargando = true;
      await this.axios.get(
        `${BASE_URL}/${data.publicKey}`,
        {
          responseType: 'blob',
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.progresoDescarga = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
            }
          },
        },
      )
        .then((res) => {
          if (origen === 'expedientes') {
            fileDownload(res.data,
              `${data.etapa}_${data.documento.orden}_${data.contrato.numero}_${data.documento.descripcion}${data.referencia ? '_'
                : ''}${data.referencia ? data.referencia : ''}.pdf`);
          }
          if (origen === 'documentosRelacionados') {
            fileDownload(res.data, `${data.descripcion}.${data.extension}`);
          }
          if (origen === 'solicitudesPagos') {
            fileDownload(res.data, `${data.nombre}.${data.extension}`);
          }
          if (origen === 'proyectoDocumentos') {
            fileDownload(res.data, `${data.name}.${data.extension}`);
          }
        })
        .catch((err) => {
          this.mixMensajeError(obtenerMensajeError(err));
        });
      this.mostrarDescargando = false;

      this.progresoDescarga = null;
    },

    async mixGetPdf(data) {
      if (data.publicKey) {
        await this.axios.get(
          `${BASE_URL}/${data.publicKey}`,
          {
            responseType: 'blob',
            onDownloadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                this.progresoDescarga = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total,
                );
              }
            },
          },
        )
          .then((res) => {
            this.archivoDescarga = res.data;
            this.rutaArchivo = URL.createObjectURL(new Blob([res.data], {
              type: 'application/pdf',
            }));
          })
          .catch((err) => {
            this.mixMensajeError(obtenerMensajeError(err));
          });
      }
    },

    async mixExportarDocumentosPdf(tituloDocumento) {
      this.mostrarDescargando = true;
      await this.axios({
        method: 'POST',
        url: `${BASE_URL}/generarZip`,
        responseType: 'blob',
        data: {
          nombreDocumento: tituloDocumento,
          keys: this.getSoloPublicKeys,
          estructura: this.estructuraZip,
        },
        onDownloadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            this.progresoDescarga = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );
          }
        },
      })
        .then((res) => {
          fileDownload(res.data, `${tituloDocumento}.zip`);
        })
        .catch((err) => {
          this.mixMensajeError(obtenerMensajeError(err));
        });
      this.mostrarDescargando = false;
      this.progresoDescarga = null;
    },
  },
};
